import { render, staticRenderFns } from "./platform-button.vue?vue&type=template&id=107e3ca0&scoped=true&"
import script from "./platform-button.vue?vue&type=script&lang=ts&"
export * from "./platform-button.vue?vue&type=script&lang=ts&"
import style0 from "./platform-button.vue?vue&type=style&index=0&id=107e3ca0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107e3ca0",
  null
  
)

export default component.exports